export const getTime = (dateTime = new Date().toISOString()) => {
    const date = new Date(dateTime);
    return addZero(date.getHours(), date.getMinutes(), date.getSeconds());
};
const addZero = (...args) => args.map((item) => item.toString().padStart(2, "0")).join(":");
